import React from 'react';
import { styled } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import theme from 'theme';
import { Colors } from 'library';
import { SIDEBAR_WIDTH } from 'parent-portal/navigation/LayoutSidebar';
import { Icon } from './Icon';
import { ResponsiveRow } from './ResponsiveRow';
import { Row } from './Row';
import { Stack } from './Stack';
import { Text } from './Text';

type IconTone = 'default' | 'muted' | 'outlined' | 'accent';

interface FormFooterProps {
    icon: SvgIconComponent;
    title: string;
    summary?: string;
    iconTone?: IconTone;
    iconColor?: string;
    iconBgColor?: string;
    message?: React.ReactNode;
    actions: React.ReactNode;
}

export function FormFooter({
    icon,
    title,
    summary,
    iconTone,
    iconColor,
    iconBgColor,
    message,
    actions,
}: FormFooterProps) {
    return (
        <>
            <Spacer />
            <Bar>
                <ResponsiveRow justify="between" align="center" gap="md" collapseAt="md">
                    <Row gap="md">
                        <Icon icon={icon} size="md" tone={iconTone} iconColor={iconColor} bgColor={iconBgColor} />
                        <Stack gap="none">
                            <Text weight="semibold">{title}</Text>
                            {summary && (
                                <Text size="sm" tone="secondary">
                                    {summary}
                                </Text>
                            )}
                        </Stack>
                    </Row>
                    <Row gap="md" justify="end" align="center">
                        {message}
                        {actions}
                    </Row>
                </ResponsiveRow>
            </Bar>
        </>
    );
}

const Bar = styled('div')({
    position: 'fixed',
    bottom: 0,
    left: SIDEBAR_WIDTH,
    right: 0,
    zIndex: 1100,
    backgroundColor: Colors.white,
    borderTop: `1px solid ${Colors.border}`,
    padding: '12px 32px',
    [theme.breakpoints.down('md')]: {
        left: 0,
    },
});

const Spacer = styled('div')({
    height: 88,
    [theme.breakpoints.down('md')]: {
        height: 148,
    },
});
